export default "__VITE_ASSET__DORFMuzi__"